import * as React from 'react';

import { cn } from '@/lib/utils';


type IconProps = {
  className?: string;
};

function InboxIcon({
  className,
  children,
}: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={cn('h-5 w-5', className)}
    >
      {children}
    </svg>
  );
}

export function AttachIcon({ className }: IconProps) {
  return (
    <InboxIcon className={className}>
      <path d="M11.2501 10.8332V9.58317C11.2501 8.41275 11.2501 7.8276 10.9692 7.40722C10.8476 7.22524 10.6913 7.06899 10.5093 6.94739C10.1422 6.70201 9.64916 6.671 8.75008 6.66707C8.62 6.6665 8.48133 6.6665 8.33341 6.6665C7.16303 6.6665 6.57784 6.6665 6.15746 6.94739C5.97548 7.06899 5.81923 7.22524 5.69763 7.40722C5.41675 7.8276 5.41675 8.41275 5.41675 9.58317V14.5832C5.41675 15.7536 5.41675 16.3388 5.69763 16.7591C5.81923 16.9411 5.97548 17.0973 6.15746 17.2189C6.57784 17.4998 7.16303 17.4998 8.33341 17.4998C9.50383 17.4998 10.089 17.4998 10.5093 17.2189C10.6913 17.0973 10.8476 16.9411 10.9692 16.7591C11.1253 16.5254 11.1947 16.2408 11.2255 15.8332" />
      <path d="M8.75 9.16667V10.4167C8.75 11.5871 8.75 12.1722 9.03092 12.5926C9.1525 12.7746 9.30875 12.9308 9.49075 13.0524C9.85792 13.2978 10.3509 13.3288 11.25 13.3327C11.3801 13.3333 11.5188 13.3333 11.6667 13.3333C12.8371 13.3333 13.4222 13.3333 13.8426 13.0524C14.0246 12.9308 14.1808 12.7746 14.3024 12.5926C14.5833 12.1722 14.5833 11.5871 14.5833 10.4167V5.41667C14.5833 4.24628 14.5833 3.66109 14.3024 3.24072C14.1808 3.05873 14.0246 2.90248 13.8426 2.78088C13.4222 2.5 12.8371 2.5 11.6667 2.5C10.4963 2.5 9.91108 2.5 9.49075 2.78088C9.30875 2.90248 9.1525 3.05873 9.03092 3.24072C8.87475 3.47437 8.80542 3.75897 8.77458 4.16667" />
    </InboxIcon>
  );
}

export function SendTemplateIcon({ className }: IconProps) {
  return (
    <InboxIcon className={className}>
      <path d="M6.66675 14.1665H13.3334" />
      <path d="M6.66675 10.8335H10.0001" />
      <path d="M10.8333 2.08317V2.49984C10.8333 4.85686 10.8333 6.03537 11.5655 6.7676C12.2978 7.49984 13.4763 7.49984 15.8333 7.49984H16.2499M16.6666 8.88059V11.6665C16.6666 14.8092 16.6666 16.3806 15.6903 17.3568C14.714 18.3332 13.1426 18.3332 9.99992 18.3332C6.85722 18.3332 5.28588 18.3332 4.30956 17.3568C3.33325 16.3806 3.33325 14.8092 3.33325 11.6665V7.8797C3.33325 5.17552 3.33325 3.82343 4.07164 2.90761C4.22082 2.7226 4.38934 2.55407 4.57436 2.4049C5.49018 1.6665 6.84227 1.6665 9.54642 1.6665C10.1344 1.6665 10.4283 1.6665 10.6976 1.76151C10.7536 1.78127 10.8084 1.804 10.862 1.82963C11.1196 1.9528 11.3274 2.16067 11.7432 2.5764L15.6903 6.52353C16.172 7.00525 16.4128 7.2461 16.5398 7.55239C16.6666 7.85867 16.6666 8.1993 16.6666 8.88059Z" />
    </InboxIcon>
  );
}

export function PaymentLinkIcon({ className }: IconProps) {
  return (
    <InboxIcon className={className}>
      <path d="M1.66675 10.0002C1.66675 7.05226 1.66675 5.5783 2.54408 4.59425C2.68441 4.43685 2.83906 4.29129 3.0063 4.15922C4.05186 3.3335 5.61793 3.3335 8.75008 3.3335H11.2501C14.3822 3.3335 15.9483 3.3335 16.9938 4.15922C17.1611 4.29129 17.3157 4.43685 17.4561 4.59425C18.3334 5.5783 18.3334 7.05226 18.3334 10.0002C18.3334 12.9481 18.3334 14.422 17.4561 15.4061C17.3157 15.5635 17.1611 15.709 16.9938 15.8411C15.9483 16.6668 14.3822 16.6668 11.2501 16.6668H8.75008C5.61793 16.6668 4.05186 16.6668 3.0063 15.8411C2.83906 15.709 2.68441 15.5635 2.54408 15.4061C1.66675 14.422 1.66675 12.9481 1.66675 10.0002Z" />
      <path d="M8.33325 13.3335H9.58325" strokeMiterlimit={10} />
      <path d="M12.0833 13.3335H14.9999" strokeMiterlimit={10} />
      <path d="M1.66675 7.5H18.3334" strokeLinecap="butt" />
    </InboxIcon>
  );
}

export function WhatsAppPayIcon({ className }: IconProps) {
  return (
    <InboxIcon className={className}>
      <path d="M9.99992 17.9168C13.7318 17.9168 15.5978 17.9168 16.7573 16.7575C17.9166 15.5981 17.9166 13.7321 17.9166 10.0002C17.9166 6.2682 17.9166 4.40223 16.7573 3.24286C15.5978 2.0835 13.7318 2.0835 9.99992 2.0835C6.26797 2.0835 4.40199 2.0835 3.24262 3.24286C2.08325 4.40224 2.08325 6.26821 2.08325 10.0002C2.08325 13.7321 2.08325 15.5981 3.24262 16.7575C4.40199 17.9168 6.26796 17.9168 9.99992 17.9168Z" />
      <path d="M6.66675 8.3335H13.3334" />
      <path d="M6.66675 5.8335H13.3334" />
      <path d="M6.66675 5.8335H9.16675C10.5475 5.8335 11.6667 6.95279 11.6667 8.3335C11.6667 9.71425 10.5475 10.8335 9.16675 10.8335H6.66675L11.6667 15.0002" />
    </InboxIcon>
  );
}

export function SendProductIcon({ className }: IconProps) {
  return (
    <InboxIcon className={className}>
      <path d="M10 18.3332C9.31817 18.3332 8.66683 18.0588 7.36411 17.5101C4.12137 16.1443 2.5 15.4614 2.5 14.3127V6.28512M10 18.3332C10.6818 18.3332 11.3332 18.0588 12.6359 17.5101C15.8787 16.1443 17.5 15.4614 17.5 14.3127V6.28512M10 18.3332V10.0242M2.5 6.28512C2.5 6.79549 3.16797 7.11777 4.50393 7.76234L6.93827 8.93684C8.44067 9.66175 9.19192 10.0242 10 10.0242M2.5 6.28512C2.5 5.77475 3.16797 5.45248 4.50393 4.80791L5.83333 4.1665M17.5 6.28512C17.5 6.79549 16.832 7.11777 15.4961 7.76234L13.0617 8.93684C11.5593 9.66175 10.8081 10.0242 10 10.0242M17.5 6.28512C17.5 5.77475 16.832 5.45247 15.4961 4.80791L14.2038 4.18443M5 10.8551L6.66667 11.686" />
      <path d="M9.99683 7.49984V1.66655M9.99683 1.66655C9.77758 1.66358 9.56133 1.81674 9.40175 2.00372L8.33325 3.28172M9.99683 1.66655C10.2083 1.6694 10.4225 1.82177 10.5918 2.00372L11.6666 3.28172" />
    </InboxIcon>
  );
}

export function ScheduleMessageIcon({ className }: IconProps) {
  return (
    <InboxIcon className={className}>
      <path d="M10 6.6665V9.99984L11.25 11.2498" />
      <path d="M16.2878 13.7111C17.6514 14.4475 18.3333 14.8157 18.3333 15.4166C18.3333 16.0176 17.6514 16.3858 16.2878 17.1221L15.3592 17.6236C14.3119 18.1891 13.7884 18.4719 13.5365 18.2663C12.9199 17.7628 13.8805 16.4634 14.1169 16.0031C14.3564 15.5366 14.352 15.2882 14.1169 14.8302C13.8805 14.3699 12.9199 13.0705 13.5365 12.567C13.7884 12.3614 14.3119 12.6441 15.3592 13.2096L16.2878 13.7111Z" strokeLinecap="butt" strokeLinejoin="miter" />
      <path d="M10.8552 18.2898C10.5741 18.3185 10.2887 18.3332 10.0001 18.3332C5.39771 18.3332 1.66675 14.6022 1.66675 9.99984C1.66675 5.39746 5.39771 1.6665 10.0001 1.6665C14.6024 1.6665 18.3334 5.39746 18.3334 9.99984C18.3334 10.5706 18.276 11.128 18.1667 11.6665" />
    </InboxIcon>
  );
}

export function AssignAgentIcon({ className }: IconProps) {
  return (
    <InboxIcon className={className}>
      <path d="M2.5 17.0835C2.73681 14.0048 5.25 11.4327 8.334 11.2816C8.5945 11.2688 8.8705 11.2581 9.16667 11.25L9.99583 11.3053C10.5783 11.3441 11.1388 11.4619 11.6667 11.6481" />
      <path d="M15 12.9165V17.9165M17.5 15.4165H12.5" />
      <path d="M9.16659 8.75016C11.0075 8.75016 12.4999 7.25778 12.4999 5.41683C12.4999 3.57588 11.0075 2.0835 9.16659 2.0835C7.32564 2.0835 5.83325 3.57588 5.83325 5.41683C5.83325 7.25778 7.32564 8.75016 9.16659 8.75016Z" />
    </InboxIcon>
  );
}

export function AssignedAgentIcon({ className }: IconProps) {
  return (
    <InboxIcon className={className}>
      <path d="M16.6666 17.5C16.4274 14.3908 13.9407 11.9292 10.8291 11.7218L9.99992 11.6665C9.70375 11.6746 9.42775 11.6853 9.16725 11.6981C6.08325 11.8493 3.57006 14.4213 3.33325 17.5" />
      <path d="M10.0001 9.16667C11.841 9.16667 13.3334 7.67428 13.3334 5.83333C13.3334 3.99238 11.841 2.5 10.0001 2.5C8.15913 2.5 6.66675 3.99238 6.66675 5.83333C6.66675 7.67428 8.15913 9.16667 10.0001 9.16667Z" />
    </InboxIcon>
  );
}

export function BlockContactIcon({ className }: IconProps) {
  return (
    <InboxIcon className={className}>
      <path d="M9.99583 11.3053L9.16667 11.25C8.8705 11.2581 8.5945 11.2688 8.334 11.2816C5.25 11.4327 2.73681 14.0048 2.5 17.0835" />
      <path d="M9.16659 8.75016C11.0075 8.75016 12.4999 7.25778 12.4999 5.41683C12.4999 3.57588 11.0075 2.0835 9.16659 2.0835C7.32564 2.0835 5.83325 3.57588 5.83325 5.41683C5.83325 7.25778 7.32564 8.75016 9.16659 8.75016Z" />
      <path d="M12.9167 13.3335L16.2501 16.6668M17.5001 15.0002C17.5001 13.3893 16.1942 12.0835 14.5834 12.0835C12.9726 12.0835 11.6667 13.3893 11.6667 15.0002C11.6667 16.611 12.9726 17.9168 14.5834 17.9168C16.1942 17.9168 17.5001 16.611 17.5001 15.0002Z" />
    </InboxIcon>
  );
}
